const w = window;
const $ = jQuery;
const path = location.pathname;

/****************************
 * トップページの場合
 */
if(path == '/'){
  $(()=>{
    // 縦スライダー
    $('[data-plugin=vertical-slider]').slick({
      vertical:true,
      verticalSwiping: true,
      autoplay: true,
      arrows: false,
      dots: true
    });
    
  /****************************
   * movie background
   */
    const $MV = $('[data-plugin=ytplayer]');
    const param = (id)=> `{
videoURL: '${id}',
containment: '#mainVisual',
mute: true,
showControls: false,
autoPlay: true,
useOnMobile: true,
showYTLogo: false,
abundance: 0,
stopMovieOnBlur: false,
loop: true,
startAt: -3,
anchor: 'center,center'
    }`;
    if( $(w).width() >= 768 ){
      $MV.attr('data-property',param('v0vktGST3bE'));
    }else{
      $MV.attr('data-property',param('_AfDV8L_d6I'));
    }
    $MV.YTPlayer();
    $MV.YTPPlay();
    
  });
}